import React from 'react';
function HomeHero() {  return (
    <section className="hero" id="top" style={{ paddingBottom: "0" }}>
      <div className="hero-inner">
        <div>
          <div className="eyebrow" style={{ color: "var(--sky-bright)" }}>{"Nurturing Minds. Building Futures."}</div>
          <h1>
            {"Where Learning"}
            <br />
            {"Meets "}
            <span className="accent">{"Excellence."}</span>
          </h1>
          <p className="lede">{"At Comprehensive High School, we empower students to grow academically, socially and emotionally — inside a safe, innovative and genuinely inclusive campus."}</p>
          <div className="hero-ctas">
            <a href="#about" className="btn primary">
              {"Explore Our School\n          "}
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
                <path d="M5 12h14M13 6l6 6-6 6"></path>
              </svg>
            </a>
            <a href="#chairman" className="btn ghost">
              {"Chairman's Message\n          "}
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M10 9l5 3-5 3V9z" fill="currentColor" stroke="none"></path>
              </svg>
            </a>
          </div>
          <div className="hero-dots">
            <span className="on"></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <div className="hero-visual">
          <div className="hero-photo">
            <img src='/image/hero.png'/>
          </div>
          <div className="hero-badge">
            <div className="ic">
              <svg viewBox="0 0 24 24" fill="none" stroke="#3FA9E0" strokeWidth="2">
                <path d="M9 12l2 2 4-4"></path>
                <circle cx="12" cy="12" r="9"></circle>
              </svg>
            </div>
            <div>
              <b>{"Accredited Curriculum"}</b>
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeHero;
